import { IStepCardProps } from "@/interfaces";
import { cn } from "@/lib/utils";

import { FlexCol } from "../ui";
import { useTranslations } from "next-intl";

const StepCard = ({
  title,
  description,
  link,
  index,
  className,
}: IStepCardProps) => {
  const t = useTranslations();
  return (
    <article
      className={cn(
        "relative w-full basis-full text-center sm:basis-1/3 sm:text-justify",
        className,
      )}
    >
      <span
        className={cn(
          "absolute -top-[45px] left-1/2 -translate-x-1/2 transform text-center",
          "text-custom-main-light-2 text-8xl font-bold sm:text-8xl",
        )}
        aria-hidden="true"
      >
        {index + 1}
      </span>

      <FlexCol
        gap={2}
        className="relative z-10 mx-auto w-1/2 text-lg sm:w-full xl:gap-4"
      >
        <span className={cn("text-sm font-bold lg:text-lg xl:text-xl")}>
          {t(title as any)}
        </span>
        <p className="text-custom-gray-200 text-xs leading-6 lg:text-sm xl:text-base">
          {t(description as any)}
        </p>

        {/* ⚠ WARNING: Do not remove the Link. */}

        {/* <Link title={'لینک'}
          href={link.href}
          className="text-primary text-primary-main hover:text-secondary-main mt-4 flex w-max items-center gap-2 transition-colors"
        >
          <p>{link.label}</p>
          <ArrowLeft size={22} />
        </Link> */}
      </FlexCol>
    </article>
  );
};

export default StepCard;
